import { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, CircularProgress, DialogTitle, Modal, ModalClose, ModalDialog, Stack, Typography } from '@mui/joy';
import DownloadRounded from '@mui/icons-material/DownloadRounded';
import { documentBinary, downloadTemplateFile } from './documentSettingsApi';

export default function TemplatePreviewModal({ template, token, onClose }) {
  const [state, setState] = useState({});
  const [downloadError, setDownloadError] = useState('');
  const [downloading, setDownloading] = useState(false);
  const scopeRef = useRef(null);
  if (scopeRef.current?.template !== template || scopeRef.current?.token !== token) scopeRef.current = { template, token, active: true };
  const scope = scopeRef.current;
  useEffect(() => {
    let url;
    const controller = new AbortController();
    scope.active = true; setDownloadError(''); setDownloading(false);
    if (!template) { setState({}); return () => { scope.active = false; }; }
    setState({ scope, loading: true });
    documentBinary(`templates/${template.id}/file/?kind=pdf`, { token, signal: controller.signal })
      .then(result => {
        if (!scope.active || scopeRef.current !== scope) return;
        url = URL.createObjectURL(result.blob); setState({ scope, url });
      }).catch(error => {
        if (!controller.signal.aborted && scope.active && scopeRef.current === scope) setState({ scope, error: error.message });
      });
    return () => { scope.active = false; controller.abort(); if (url) URL.revokeObjectURL(url); };
  }, [template, token, scope]);
  const download = async () => {
    setDownloading(true); setDownloadError('');
    try { await downloadTemplateFile(template.id, token, { isCurrent: () => scope.active && scopeRef.current === scope }); }
    catch (error) { if (scope.active && scopeRef.current === scope) setDownloadError(error.message); }
    finally { if (scope.active && scopeRef.current === scope) setDownloading(false); }
  };
  if (!template) return null;
  const current = state.scope === scope ? state : { loading: true };
  return <Modal open onClose={onClose} sx={{ zIndex: 110100 }}>
    <ModalDialog sx={{ width: 900, minWidth: 0, maxWidth: 'calc(100vw - 24px)', height: '88dvh', maxHeight: 'calc(100dvh - 24px)', p: { xs: 1.5, sm: 2 }, gap: 1.25, overflow: 'hidden', borderRadius: 'xl' }}>
      <ModalClose />
      <DialogTitle sx={{ pr: 4, overflowWrap: 'anywhere' }}>{template.name}</DialogTitle>
      <Typography level="body-sm" sx={{ color: 'text.secondary' }}>Текущий шаблон · версия {template.version}. Здесь видны поля-заготовки, без данных конкретного заказа.</Typography>
      {downloadError && <Alert color="danger">{downloadError}</Alert>}
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', bgcolor: 'background.level1', borderRadius: 'lg', overflow: 'hidden' }}>
        {current.loading ? <Stack alignItems="center" justifyContent="center" spacing={1.5} sx={{ width: '100%' }}><CircularProgress /><Typography level="body-sm">Подготавливаем просмотр шаблона…</Typography></Stack>
          : current.error ? <Stack gap={2} sx={{ p: 2, overflowY: 'auto' }}><Alert color="warning">{current.error}</Alert><Typography level="body-sm">Исходный DOCX можно скачать и открыть в Word или LibreOffice.</Typography></Stack>
            : <iframe title={`Текущий шаблон ${template.name}`} src={current.url} style={{ width: '100%', height: '100%', border: 0 }} />}
      </Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end">
        <Button variant="soft" onClick={onClose}>Закрыть</Button>
        <Button loading={downloading} onClick={download} startDecorator={<DownloadRounded />}>Скачать текущий DOCX</Button>
      </Stack>
    </ModalDialog>
  </Modal>;
}
